<!--
 * @Descripttion : 省市选择器
 * @version      : 
 * @Author       : karl
 * @Date         : 2022-07-22 15:41:37
 * @LastEditors  : 
 * @LastEditTime : 
-->
<template>
    <a-cascader :options="options" v-model="defaultProvinceCity" :placeholder="placeholder" :fieldNames="{ label: 'name', value: 'id', children: 'values' }" @change="onChange" :allowClear="false" />
</template>

<script>
import { GetProvinceAndCityAndAreaList } from "@/api/saasV5";
const CACHE_KEY = 'region_data_cache';
const CACHE_EXPIRY_KEY = 'region_data_cache_expiry';
const CACHE_DURATION = 3 * 30 * 24 * 60 * 60 * 1000; // 3个月的毫秒数
export default {
    props: {
        placeholder: {
            type: String,
            default: "请选择地址"
        },
        selectedProvinceCity: {
            type: Array,
            default: null
        }
    },
    watch: {
        selectedProvinceCity(o, n) {
            console.log(o, n);
            this.defaultProvinceCity = this.selectedProvinceCity;
        }
    },
    data() {
        return {
            options: [],
            defaultProvinceCity: null
        };
    },
    mounted() {
        const cachedData = this.getCachedRegionData();
        if (cachedData) {
            this.$nextTick(() => {
                // this.options = cachedData;
                //重组省市
                this.reorganizeData(cachedData);
            });
        } else {
            GetProvinceAndCityAndAreaList({
                json: true
            }).then(res => {
                this.setCachedRegionData(res.data); // 缓存数据
                this.$nextTick(() => {
                    // this.options = res.data;
                    //重组省市
                    this.reorganizeData(res.data);
                });
            })
        }
    },
    methods: {
        onChange(value, selectedOptions) {
            // 选中数据返回给父级
            console.log(value, selectedOptions);
            console.log('val:', JSON.stringify(value), JSON.stringify(selectedOptions));
            if (selectedOptions) {
                this.$emit("change", selectedOptions);
            }
        },
        // 获取缓存数据
        getCachedRegionData() {
            try {
                const cachedData = localStorage.getItem(CACHE_KEY);
                const expiryTime = localStorage.getItem(CACHE_EXPIRY_KEY);
                if (cachedData && expiryTime && Date.now() < Number(expiryTime)) {
                    return JSON.parse(decodeURIComponent(cachedData));
                }
                return null;
            } catch (error) {
                console.warn('解析失败，清理缓存:', error);
                clearRegionCache();
                return null;
            }
        },
        // 设置缓存数据
        setCachedRegionData(data) {
            try {
                const expiryTime = Date.now() + CACHE_DURATION;
                const encodedData = encodeURIComponent(JSON.stringify(data));
                localStorage.setItem(CACHE_KEY, encodedData);
                localStorage.setItem(CACHE_EXPIRY_KEY, expiryTime.toString());
            } catch (error) {
                console.error('存储失败，请联系管理员！', error);
                clearRegionCache();
            }
        },
        // 清理缓存
        clearRegionCache() {
            localStorage.removeItem(CACHE_KEY);
            localStorage.removeItem(CACHE_EXPIRY_KEY);
        },
        reorganizeData(data) {
            //重组省市
            data.forEach(item => {
                let _cityArry = [];
                item.values.forEach(items => {
                    _cityArry.push({
                        id: items.id,
                        name: items.name
                    })
                })
                this.options.push({
                    id: item.id,
                    name: item.name,
                    values: _cityArry
                })
            })
        }
    }
};
</script>
<style lang="scss" scoped></style>